import { changePasswordService, getApplicationsService } from '../../services/password.service';
import { checkingPreload, unCheckingPreload } from '../loading';
import { setSaving, stopSaving, setAplicationsList } from './PasswordSlice';

export const startChangePassword = (data: any) => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      await dispatch(setSaving());

      const result = await changePasswordService(data);

      dispatch(stopSaving());
      dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('startChangePassword thunk error:', error);
      dispatch(stopSaving());
      dispatch(unCheckingPreload());
      return { ok: false, errors: ['Ocurrió un error inesperado'] };
    }
  };
};

export const startGetApplications = () => {
  return async (dispatch: any) => {
    try {
      const response = await getApplicationsService();
      if (response.ok) {
        dispatch(setAplicationsList(response.data || []));
      }
      return response;
    } catch (error) {
      console.log('startGetApplications thunk error:', error);
      return { ok: false, data: [] };
    }
  };
};
